export const SKIP_AUTHENTICATION_HEADER = 'skipAuthentication'
